import { Fragment, useState, useEffect } from 'react';
import Paginator from 'react-hooks-paginator';

import { useLocation } from "react-router-dom"
import { getSortedProducts } from '../../helpers/product';
import SEO from "../../components/seo";
import LayoutOne from '../../layouts/LayoutOne';
import Breadcrumb from '../../wrappers/breadcrumb/Breadcrumb';
import ShopSidebar from '../../wrappers/product/ShopSidebar';
import ShopTopbar from '../../wrappers/product/ShopTopbar';
import ShopProducts from '../../wrappers/product/ShopProducts';
import { useSelector, useDispatch } from "react-redux";
import { limpiaPrincipioActivo } from "../../store/slices/bioequivalente-slice";
import { setModalidadSeleccionada } from '../../store/slices/modalidad-slice';

// const arregloSinFoto = 
//     [
//         {
//             "kinf": "01793",
//             "pres": 1,
//             "nombre_medicamento": "ACEMUK 100MG/ML"
//         },
//         {
//             "kinf": "01210",
//             "pres": 1,
//             "nombre_medicamento": "BREXOVENT LF 125 MCG"
//         },
//         {
//             "kinf": "01763",
//             "pres": 50,
//             "nombre_medicamento": "CARBORON RTD 400 MG X 50"
//         },
//         {
//             "kinf": "90021",
//             "pres": 20,
//             "nombre_medicamento": "CB-FERROSO SULFATO 200 MG CAJ "
//         },
//         {
//             "kinf": "90078",
//             "pres": 20,
//             "nombre_medicamento": "CB-HALOPERIDOL 5MG (BE)"
//         },
//         {
//             "kinf": "90080",
//             "pres": 20,
//             "nombre_medicamento": "CB-SINOGAN 25 MG"
//         },
//         {
//             "kinf": "01806",
//             "pres": 10,
//             "nombre_medicamento": "CLEXANE 40MG/0.4ML"
//         },
//         {
//             "kinf": "01699",
//             "pres": 6,
//             "nombre_medicamento": "CLOTRIMAZOL OVULOS X6"
//         },
//         {
//             "kinf": "00073",
//             "pres": 30,
//             "nombre_medicamento": "CONCERTA 36 MG"
//         },
//         {
//             "kinf": "00619",
//             "pres": 28,
//             "nombre_medicamento": "COPLAVIX 75 / 100"
//         },
//         {
//             "kinf": "00884",
//             "pres": 1,
//             "nombre_medicamento": "CUROCEF 250 MG SUSP. ORAL"
//         },
//         {
//             "kinf": "01795",
//             "pres": 30,
//             "nombre_medicamento": "DESVENLAFAXINA  50 MG"
//         },
//         {
//             "kinf": "01796",
//             "pres": 30,
//             "nombre_medicamento": "DESVENLAFAXINA 100 MG"
//         },
//         {
//             "kinf": "00096",
//             "pres": 100,
//             "nombre_medicamento": "DIAZEPAM AMPOLLAS"
//         },
//         {
//             "kinf": "01293",
//             "pres": 1,
//             "nombre_medicamento": "DOSIN 10MG/ML"
//         },
//         {
//             "kinf": "01692",
//             "pres": 30,
//             "nombre_medicamento": "DUTASVITAE 0.5 MG"
//         },
//         {
//             "kinf": "00109",
//             "pres": 60,
//             "nombre_medicamento": "ELEVAL  50 MG (BE)"
//         },
//         {
//             "kinf": "00108",
//             "pres": 30,
//             "nombre_medicamento": "ELEVAL 100 MG (BE)"
//         },
//         {
//             "kinf": "01044",
//             "pres": 20,
//             "nombre_medicamento": "ENALAPRIL  5 MG (BE)"
//         },
//         {
//             "kinf": "01710",
//             "pres": 4,
//             "nombre_medicamento": "ERELZI 50MG/ML X 4 INYECTORES"
//         },
//         {
//             "kinf": "00120",
//             "pres": 240,
//             "nombre_medicamento": "FENOBARBITAL  15 MG"
//         },
//         {
//             "kinf": "01768",
//             "pres": 28,
//             "nombre_medicamento": "FIRIALTA 20 MG X 28 COMP"
//         },
//         {
//             "kinf": "01794",
//             "pres": 1,
//             "nombre_medicamento": "GELACNE "
//         },
//         {
//             "kinf": "01802",
//             "pres": 30,
//             "nombre_medicamento": "GLAFORNIL XR  850 MG"
//         },
//         {
//             "kinf": "00840",
//             "pres": 1,
//             "nombre_medicamento": "HIDROXIDO ALUMINIO 6 % SOL."
//         },
//         {
//             "kinf": "01784",
//             "pres": 2,
//             "nombre_medicamento": "IDACIO 40MG/0.8ML"
//         },
//         {
//             "kinf": "00830",
//             "pres": 1,
//             "nombre_medicamento": "IDON GOTAS 10 MG/ML"
//         },
//         {
//             "kinf": "01778",
//             "pres": 1,
//             "nombre_medicamento": "INVEGA HAFYERA 1000 MG INY LP"
//         },
//         {
//             "kinf": "01777",
//             "pres": 1,
//             "nombre_medicamento": "INVEGA HAFYERA 700 MG INY LP"
//         },
//         {
//             "kinf": "01445",
//             "pres": 1,
//             "nombre_medicamento": "KETOVIE 4:1 CHOCOLATE"
//         },
//         {
//             "kinf": "01798",
//             "pres": 30,
//             "nombre_medicamento": "LEOVAL  500 MG (BE)"
//         },
//         {
//             "kinf": "01799",
//             "pres": 30,
//             "nombre_medicamento": "LEOVAL 1000 MG (BE)"
//         },
//         {
//             "kinf": "01800",
//             "pres": 1,
//             "nombre_medicamento": "LEOVAL SOLUCION (BE)"
//         },
//         {
//             "kinf": "01579",
//             "pres": 28,
//             "nombre_medicamento": "LEVONORGESTREL 0.03 MG"
//         },
//         {
//             "kinf": "00157",
//             "pres": 30,
//             "nombre_medicamento": "MENTIX 200 MG"
//         },
//         {
//             "kinf": "01691",
//             "pres": 28,
//             "nombre_medicamento": "NEBIVITAE 5 MG"
//         },
//         {
//             "kinf": "00861",
//             "pres": 12,
//             "nombre_medicamento": "NISTATINA 100000 UI OVULOS"
//         },
//         {
//             "kinf": "01466",
//             "pres": 60,
//             "nombre_medicamento": "NOVALIF"
//         },
//         {
//             "kinf": "01732",
//             "pres": 1,
//             "nombre_medicamento": "NUCALA 100 MG INYECTABLE"
//         },
//         {
//             "kinf": "01791",
//             "pres": 1,
//             "nombre_medicamento": "PALDAR 2% UNG "
//         },
//         {
//             "kinf": "01430",
//             "pres": 1,
//             "nombre_medicamento": "PASTILLERO SEMANAL 4 TOMAS"
//         },
//         {
//             "kinf": "01503",
//             "pres": 10,
//             "nombre_medicamento": "PERENTERYL SOBRES"
//         },
//         {
//             "kinf": "01792",
//             "pres": 1,
//             "nombre_medicamento": "PLUSTER NASAL 50 MCG"
//         },
//         {
//             "kinf": "01627",
//             "pres": 30,
//             "nombre_medicamento": "PROBIOTIX KIDS & TEENS"
//         },
//         {
//             "kinf": "00963",
//             "pres": 1000,
//             "nombre_medicamento": "PROPRANOLOL 10 MG (BE)"
//         },
//         {
//             "kinf": "00699",
//             "pres": 30,
//             "nombre_medicamento": "REALTA 30 MG"
//         },
//         {
//             "kinf": "00700",
//             "pres": 30,
//             "nombre_medicamento": "REALTA 60 MG"
//         },
//         {
//             "kinf": "01787",
//             "pres": 1,
//             "nombre_medicamento": "RISTRIONA 25 MG"
//         },
//         {
//             "kinf": "01788",
//             "pres": 1,
//             "nombre_medicamento": "RISTRIONA 37.5 MG"
//         },
//         {
//             "kinf": "00388",
//             "pres": 30,
//             "nombre_medicamento": "SENEXON SR  75 MG"
//         },
//         {
//             "kinf": "01521",
//             "pres": 1,
//             "nombre_medicamento": "TAPSIN CALIENTE DIA"
//         },
//         {
//             "kinf": "01520",
//             "pres": 18,
//             "nombre_medicamento": "TAPSIN COMPUESTO D.N. CAPS"
//         },
//         {
//             "kinf": "00253",
//             "pres": 20,
//             "nombre_medicamento": "TEGRETAL CR 200 MG"
//         },
//         {
//             "kinf": "01805",
//             "pres": 1,
//             "nombre_medicamento": "TOUJEO 300 IU/ML SOLOSTAR"
//         },
//         {
//             "kinf": "01789",
//             "pres": 20,
//             "nombre_medicamento": "TRIBUTAN X 20"
//         },
//         {
//             "kinf": "01786",
//             "pres": 30,
//             "nombre_medicamento": "VEGAN OMEGA 3 UP X 30 CAP"
//         },
//         {
//             "kinf": "01748",
//             "pres": 4,
//             "nombre_medicamento": "VIDYN 50.000 UI X 4 CAPS"
//         },
//         {
//             "kinf": "01586",
//             "pres": 30,
//             "nombre_medicamento": "VITAKRON HOMBRE"
//         },
//         {
//             "kinf": "01585",
//             "pres": 30,
//             "nombre_medicamento": "VITAKRON MUJER"
//         },
//         {
//             "kinf": "01785",
//             "pres": 60,
//             "nombre_medicamento": "VITAMIN UP CRANBERRY"
//         },
//         {
//             "kinf": "01222",
//             "pres": 30,
//             "nombre_medicamento": "XUZAL 5 MG (R)"
//         }
//     ]
import arrModalidad from '../../store/dataModalidad';

const ShopGridStandard = () => {
    const [layout, setLayout] = useState('grid three-column');
    const [sortType, setSortType] = useState('');
    const [sortValue, setSortValue] = useState('');
    const [filterSortType, setFilterSortType] = useState('');
    const [filterSortValue, setFilterSortValue] = useState('');
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentData, setCurrentData] = useState([]);
    const [sortedProducts, setSortedProducts] = useState([]);
    const { products } = useSelector((state) => state.product);
    const dispatch = useDispatch();
    const { principioActivo } = useSelector((state) => state.bioequivalente);
    const { concentracion } = useSelector((state) => state.bioequivalente)

    const pageLimit = 15;
    let { pathname } = useLocation();



    const getLayout = (layout) => {
        setLayout(layout)
    }

    const getSortParams = (sortType, sortValue) => {
        setSortType(sortType);
        setSortValue(sortValue);
    }

    const getFilterSortParams = (sortType, sortValue) => {
        setFilterSortType(sortType);
        setFilterSortValue(sortValue);
    }



    const { search } = useLocation();
    const params = new URLSearchParams(search);

    //const [categoria, setCategoria] = useState()
    //var categoria = params.get('categoria');
    const [filtroCategoria, setFiltroCategoria] = useState(null)

    useEffect(() => {

        let cat = params.get('categoria')
        //console.log("pasa por SET PARAMS")
        //console.log(sortValue);
        if(sortValue){
            //console.log("sort value existe");
            return limpiaCategoria()
        }
        if (filtroCategoria === null || filtroCategoria !== cat) {
            let categoriaParams = params.get('categoria')
            ////console.log("filtro: " + filtroCategoria)
            setFiltroCategoria(categoriaParams)
        }
        return;

    }, [params, sortValue])

    const limpiaCategoria = () => {
        setFiltroCategoria("SIN CATEGORIA")
    }
    const [arregloSinFoto, setArregloSinFoto] = useState([]);

    // useEffect(() => {

    //     //console.log("useeffect")
    //     let modalidadParams = params.get('modalidad')
    //     //console.log(modalidadParams)
    //     if (modalidadParams) {
    //         //console.log("modalidad valido")
    //         const arrMod = arrModalidad.filter(mod => mod.id == modalidadParams)
    //         if (arrMod.length >= 0) {
    //             // console.log("arreglo valido")
    //             // console.log(arrMod)
    //             // console.log(arrMod[0])
    //             dispatch(setModalidadSeleccionada(arrMod[0]))
    //         }

    //     }
    // }, []);


    useEffect(() => {
     
 

        const sinfoto = products.filter(product => product.image[0] === "/assets/img/sin_foto.png")
        // console.log("medicamentos sin foto")
        // console.log(productsFull)
        let arrSinFoto = []
        sinfoto.forEach(item => {
            let obj =
            {
                kinf: item.kinf,
                pres: item.pres,
                nombre_medicamento: item.nombre_medicamento
            }
            arrSinFoto.push(obj)
        })
        //console.log(arrSinFoto)
        //setArregloSinFoto(arrSinFoto)
        //console.log(arreglo)

        ////console.log("categoria" + filtroCategoria)
        let sortedProducts = getSortedProducts(products, sortType, sortValue);
        const filterSortedProducts = getSortedProducts(sortedProducts, filterSortType, filterSortValue);
        sortedProducts = filterSortedProducts;

        // //console.log("principio activo")
        // //console.log(principioActivo)


        //filtra el arreglo de productos por categoria, si la categoria esta incluida en el arreglo categorias del producto y si no hay categoria, no filtra, si el arreglo ya esta filtrado por la categoría, no filtra

        if (sortValue) {
            
            //setFiltroCategoria("SIN CATEGORIA")
            limpiaCategoria()
            setSortedProducts(sortedProducts);
            setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
            return;
        }

        if (filtroCategoria === "CENABAST") {
            sortedProducts = sortedProducts.filter(producto => producto.nombre_medicamento.startsWith("CB-"));
            ////console.log("despues de ")
            ////console.log(sortedProducts.length)
            if (sortedProducts.length === 0) {
                sortedProducts = filterSortedProducts;
                setSortedProducts(sortedProducts);
                setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
                return
            }
            setSortedProducts(sortedProducts);
            setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
            ////console.log(filtroCategoria)
            ////console.log(sortType, sortValue)
            ////console.log(filterSortType, filterSortValue)
            ////console.log(offset)
            return;
        }

        if (filtroCategoria !== null && filtroCategoria !== "SIN CATEGORIA") {

            sortedProducts = sortedProducts.filter(producto => producto.categorias.includes(filtroCategoria));

            if (sortedProducts.length === 0) {
                sortedProducts = filterSortedProducts;
                setSortedProducts(sortedProducts);
                setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
                return
            }
            setSortedProducts(sortedProducts);
            setCurrentData(sortedProducts.slice(offset, offset + pageLimit));

        }
        else {
            sortedProducts = filterSortedProducts;
            setSortedProducts(sortedProducts);
            setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
        }



    }, [offset, products, sortType, sortValue, filterSortType, filterSortValue, principioActivo, concentracion]);

    return (
        <Fragment>
            <SEO
                titleTemplate="Compra de Medicamentos"
                description="Venta Online 2.0 - Liga Chilena contra la Epilepsia - Farmacia Online."
            />

            <LayoutOne headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb
                    pages={[
                        { label: "Home", path: process.env.PUBLIC_URL + "/" },
                        { label: "Medicamentos", path: process.env.PUBLIC_URL + pathname }
                    ]}
                />

                <div className="shop-area pt-50 pb-60">
                    <div className="container">
                        {principioActivo ?
                            <div
                                className="d-flex justify-content-center pb-3"
                            ><p className="p-bioeq">Listando bioequivalentes de {principioActivo} {concentracion} <button className="boton" onClick={() => dispatch(limpiaPrincipioActivo())}>Eliminar filtro</button></p>
                            </div>
                            :

                            null
                        }

                        <div className="row">

                            <div className="col-lg-3 order-1">
                                {/* shop sidebar */}
                                <ShopSidebar products={products} getSortParams={getSortParams} sideSpaceClass="mr-30" />
                            </div>
                            <div className="col-lg-9 order-1 order-lg-2">
                                {
                                    filtroCategoria !== "SIN CATEGORIA" && filtroCategoria !== null ?
                                        <div
                                            className="d-flex justify-content-start pb-5"
                                        ><h3 className="h3-categoria text-capitalize">{"Categoría: "}{filtroCategoria.toLowerCase()}
                                                <button className="boton" onClick={() => limpiaCategoria()}>
                                                    Mostrar todo
                                                </button>
                                            </h3>
                                        </div>
                                        :

                                        null
                                }

                                {/* <table>
                                    {
                                        arregloSinFoto.map(item => (
                                            <tr>

                                                <td>{item.kinf}</td>
                                                <td>{item.pres}</td>
                                                <td>{item.nombre_medicamento}</td>
                                            </tr>
                                        ))
                                    }
                                </table> */}
                                {/* shop topbar default */}
                                <ShopTopbar getLayout={getLayout} getFilterSortParams={getFilterSortParams} productCount={sortedProducts.length} sortedProductCount={currentData.length} />

                                {/* shop page content default */}
                                <ShopProducts layout={layout} products={currentData} />

                                {/* shop product pagination */}
                                <div className="pro-pagination-style text-center mt-30">
                                    <Paginator
                                        totalRecords={sortedProducts.length}
                                        pageLimit={pageLimit}
                                        pageNeighbours={2}
                                        setOffset={setOffset}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        pageContainerClass="mb-0 mt-0"
                                        pagePrevText="«"
                                        pageNextText="»"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutOne>
        </Fragment>
    )
}


export default ShopGridStandard;